const TIMER_EXPIRED = 'TIMER_EXPIRED'

export function setTimeExpired() {
  return { type: TIMER_EXPIRED }
}

export function timerReducer(state = { expired: false }, action = {}) {
  switch (action.type) {
    case TIMER_EXPIRED:
      return { ...state, expired: true }
    default:
      return state
  }
}